/** Fills `:name` segments of an endpoint path from its params. */
export function buildPath(path, params = {}) {
    return path.replace(/:([A-Za-z0-9_]+)/g, (_match, name) => {
        const value = params[name];
        if (value === undefined || value === null) {
            throw new Error(`Missing path parameter "${name}" for "${path}"`);
        }
        return encodeURIComponent(String(value));
    });
}
//# sourceMappingURL=endpoint.js.map